


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { VantivAccountAddOrUpdateViewModel } from '@/models/payment/vantivAccount';
import { Base } from '@/components/common/base';
import {storeService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class AddVantivAccountPage extends Base {
  public vm: VantivAccountAddOrUpdateViewModel = new VantivAccountAddOrUpdateViewModel();
  public vantivTypes: any[] = [];
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public disableSubmitButton: boolean = false;
  public isVantivTypeLoading: boolean = false;
  public isVantivLoading: boolean = false;

  public created(): void {
    this.setFields();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.vantivaccounts',
        params: { storeId: this.vm.storeId.toString() },
      });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('vantivAccounts.alertFormInvalid'));
        this.resetMethodName(methodName);
        return;
      }
      this.submitVantivAccount();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('vantivAccounts.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('vantivAccounts.btnBack'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'vantivAccounts');

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.setFields();
    this.vm.storeId = Number(this.$route.params.storeId);
    if (this.$route.params.type) {
      this.vm.type = this.$route.params.type;
    }
    this.getVantivAccountDetails();
  }

  public setFields(): void {
    this.formFields = [
      {
        key: 'type',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: this.$t('vantivAccounts.vantivAccountFields.type') as string,
          items: this.vantivTypes,
          required: true,
          text: 'description',
          value: 'text',
          disabled: false,
          altag: 'Type',
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Type',v)
          ]
        },
      },
      {
        key: 'accountId',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: this.$t(
            'vantivAccounts.vantivAccountFields.accountId'
          ) as string,
          required: true,
          disabled: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Account Id',v)
          ]
        },
      },
      {
        key: 'acceptorId',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: this.$t(
            'vantivAccounts.vantivAccountFields.acceptorId'
          ) as string,
          required: true,
          disabled: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Acceptor Id',v)
          ]
        },
      },
      {
        key: 'accountToken',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'vantivAccounts.vantivAccountFields.accountToken'
          ) as string,
          required: true,
          disabled: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Account Token',v)
          ]
        },
      },
      {
        key: 'applicationId',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 20,
          label: this.$t(
            'vantivAccounts.vantivAccountFields.applicationId'
          ) as string,
          required: true,
          disabled: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Application Id',v)
          ]
        },
      },
      {
        key: 'applicationName',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: this.$t(
            'vantivAccounts.vantivAccountFields.applicationName'
          ) as string,
          required: true,
          disabled: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Application Name',v)
          ]
        },
      },
      {
        key: 'applicationVersion',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 20,
          label: this.$t(
            'vantivAccounts.vantivAccountFields.applicationVersion'
          ) as string,
          required: true,
          disabled: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Application Version',v)
          ]
        },
      },
      {
        key: 'authorization',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 20,
          label: this.$t(
            'vantivAccounts.vantivAccountFields.authorization'
          ) as string,
          required: true,
          disabled: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Authorization',v)
          ]
        },
      },
      {
        key: 'expressXmlEndpoint',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'vantivAccounts.vantivAccountFields.expressXmlEndpoint'
          ) as string,
          required: true,
          disabled: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Express XML Endpoint',v)
          ]
        },
      },
      {
        key: 'hostedPaymentEndpoint',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'vantivAccounts.vantivAccountFields.hostedPaymentEndpoint'
          ) as string,
          required: true,
          disabled: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Hosted Payment Endpoint',v)
          ]
        },
      },
      {
        key: 'laneUrl',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'vantivAccounts.vantivAccountFields.laneUrl'
          ) as string,
          required: true,
          disabled: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Lane Url',v)
          ]
        },
      },
      {
        key: 'saleUrl',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'vantivAccounts.vantivAccountFields.saleUrl'
          ) as string,
          required: true,
          disabled: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Sale Url',v)
          ]
        },
      },
    ];
  }

  public validateVantivAccount(): Vue & { validate: () => boolean } {
    return this.$refs.vantivAccountForm as Vue & { validate: () => boolean };
  }

  public async submitVantivAccount(): Promise<void> {
    if(this.validateVantivAccount().validate()) {
      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        const selectedDesc = this.vantivTypes.filter((m) => {
          return m.text === this.vm.account.type;
        })[0];
        this.vm.account.typeDesc = selectedDesc.description;
        await storeService.saveVativAccounts(
          this.vm.storeId,
          this.vm.account
        );
        this.showAlert(true, this.$t('vantivAccounts.alertSaveVantivAccount'));
        this.$router.push({
          name: 'admin.vantivaccounts',
          params: { storeId: this.vm.storeId.toString() },
        });
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }

  public async getVantivAccountDetails(): Promise<void> {
    try {
      if (this.vm.type) {
        this.formlyShowSkeleton(this.formFields);
      }

      this.formlyShowSkeleton(this.formFields, 'type');

      const showAll = this.vm.type ? true : false;
      const response = await storeService.getVantivAccountDetails(
        this.vm.storeId,
        this.vm.type,
        showAll
      );
      if (this.vm.type) {
        this.vm.account = response.vantivAccountByTypeResponse;
      }

      // vantiv types
      this.vantivTypes = response.vantivAccountTypeResponse.results;
      const type = this.formFields.find((m) => {
        return m.key === 'type';
      });
      if (type) {
        type.templateOptions.items = this.vantivTypes;
      }
    } finally {
      if (this.vm.type) {
        this.formlyHideSkeleton(this.formFields);
      }

      this.formlyHideSkeleton(this.formFields, 'type');
    }
  }
}
